import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class ResultModel extends Model 
{
	@attr('date') assignedStartTime;
	@attr bib;
	@attr firstName
	@attr lastName;
	@attr DOB;
	@attr id1;
	@attr id2;
	@attr id3;
	@attr pts1;
	@attr pts2;
	@attr pts3;
	@attr pts4;
	@attr pts5;
	@attr club;
	@attr town;
	@attr state;
	@attr country;
	@attr text1;
	@attr text2;
	@attr text3;
	@attr('date') startTime;
	@attr('date') finishTime;	
	@attr status;
	@attr className;
	@attr classGroupName;
	@attr({defaultValue: 0}) place;
	@attr classPlace;
	@attr('boolean') isTie;
	@attr tieOrder;
	@attr splits;
	@attr segments;
	@attr points;//for enduro
	@attr('date') finishSplit;
	@attr finishSplitPlace;
	@attr totalTimeInMilliseconds;
	@attr penaltyTimeInMilliseconds;
	@attr totalTimeWithoutPenaltyInMilliseconds;
	@attr timeBackInMilliseconds;
	@attr totalTimeFormatted;
	@attr timeBackFormatted;
	@attr totalTimeWithoutPenaltyFormatted;
	@attr penaltyTimeFormatted;
	
	@belongsTo('event', {inverse: 'results', async: true}) EventId;
	@belongsTo('class-group', {inverse: 'results', async: true}) ClassGroupId;
	@belongsTo('class', {inverse: null, async: true}) ClassId;
	
	get placeOrStatus()
	{
		const status = this.status;
		const place = this.place;
		
		if(status == 'OK')
			return place;
		return status;
	}
}
